import "core-js/modules/es6.array.find";
import { flattenChildren } from '../flattenChildren/flattenChildren.es.js';
import { isComponentType } from '../isComponentType/isComponentType.es.js';

var findChildByType = function findChildByType(children, type) {
  return flattenChildren(children).find(function (item) {
    return Array.isArray(type) ? type.some(function (component) {
      return component === item.type;
    }) : isComponentType(item, type);
  });
};

export { findChildByType };